<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div
        v-if="user"
        class="d-sm-flex d-none user-nav"
      >
        <p class="user-name font-weight-bolder mb-0">
          {{ user.firstName }} {{ user.lastName }}
        </p>
        <span class="user-status">{{ userGroup }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.avatar"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'settings-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>User Settings</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Logout</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { avatarText } from '@core/utils/filter'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    // BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: {
        // eslint-disable-next-line global-require
        avatar: require('@/assets/images/avatars/paulwilson.png'),
      },
      avatarText,
    }
  },
  computed: {
    // since we using modules you need to specfiy the modules.
    ...mapGetters('authentication', [
      'user',
      'userGroup',
    ]),
  },
  methods: {
    // The actions need to be defined before they are used.
    ...mapActions('authentication', [
      'logoutUser',
    ]),
    async logout() {
      await this.logoutUser()
      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
